module.exports = __webpack_public_path__ + "media/images/hero_images/index-1500-b43d96984f65dc7cacd76c0357eb664b.jpg";